import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ToolboxIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 27.5),
    ...svgProps,
    viewBox: "0 0 15.9 27.5",
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transform: "translate(7.12 2.62)",
      children: [/*#__PURE__*/jsx("path", {
        d: "m-5.8-1.8c2.4 2.2 1.9 1.3 3.1 2.2.4.2.7.5.8.8.5 1.1 0 2.3-1 2.8-1.1.5-2.3 0-2.8-1-.7-1.5-.7-3.2-.1-4.8z",
        strokeWidth: "1.65"
      }), /*#__PURE__*/jsx("path", {
        d: "m3.2 23.9h-4.6c-2.5 0-3.4-1.9-3.4-4.3l-1.2-8.7h13.8l-1.2 8.7c0 2.3-.8 4.3-3.4 4.3z",
        strokeWidth: "2"
      }), /*#__PURE__*/jsxs("g", {
        strokeWidth: "1.65",
        children: [/*#__PURE__*/jsx("path", {
          d: "m-2.2 4.5.9 1.8"
        }), /*#__PURE__*/jsx("path", {
          d: "m1.8 6.7 1.9-5.5 3.2-3 .6 4.3-1.4 4.2"
        }), /*#__PURE__*/jsx("path", {
          d: "m7.3 3.2c-1.4.5-2.9-.1-3.8-1.3"
        })]
      })]
    })
  });
};

export { ToolboxIcon };
//# sourceMappingURL=toolbox.js.map
